<div (offClick)="toggle(false)"
  [offClickOff]="!open">
  <div class="flex flex-middle cursor-pointer"
    (click)="toggle()">
    <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
    @if (!hideIcon) {
      <i
        class="indicator icon-arrow-down m-l-2"
      [class.flip]="open"></i>
    }
  </div>
  <div class="pos-absolute m-t-6 z-2 bg-col-w hide-up-container"
    [class.left-0]="alignOptions === 'left'"
    [class.right-0]="alignOptions !== 'left'"
    [style.min-width.%]="100">
    <div class="ng-hide-animate ng-hide hide-up"
      [class.ng-hide]="!open">

      @for (option of options; track $index) {
        <div class="cursor-pointer"
          (click)="pick(option);">
          <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: option }"></ng-container>
        </div>
      }

    </div>
  </div>
</div>
